<div class="credit-card-wallet">
  @if (title) {
    <p class="credit-card-wallet__title">{{ title }}</p>
  }
  <div class="credit-card-wallet__list">
    @for (card of savedCards; track card.id) {
      <div
        class="credit-card-wallet__item"
        [class.credit-card-wallet__item--selected]="showSelection && selectedCard?.id === card.id">
        @if (showSelection) {
          <button type="button" class="credit-card-wallet__select-button" (click)="handleSelectCardClick(card)">
            <input
              type="radio"
              class="credit-card-wallet__radio"
              tabindex="-1"
              [attr.aria-label]="'Selecionar cartão ' + card.last_four_digits"
              [checked]="selectedCard?.id === card.id" />
            <div class="credit-card-wallet__info">
              <div class="credit-card-wallet__header">
                <span class="credit-card-wallet__brand"> {{ getCardBrandIcon(card.brand) }} {{ card.brand }} </span>
                <span
                  class="credit-card-wallet__status"
                  [class.credit-card-wallet__status--active]="card.status === 'active'">
                  {{ card.status === "active" ? "Ativo" : card.status }}
                </span>
              </div>
              <div class="credit-card-wallet__number">{{ formatCardNumber(card) }}</div>
              <div class="credit-card-wallet__details">
                <span class="credit-card-wallet__holder">{{ card.holder_name }}</span>
                <span class="credit-card-wallet__expiry"> Expira em {{ formatExpiryDate(card) }} </span>
              </div>
            </div>
          </button>
        } @else {
          <div class="credit-card-wallet__info">
            <div class="credit-card-wallet__header">
              <span class="credit-card-wallet__brand"> {{ getCardBrandIcon(card.brand) }} {{ card.brand }} </span>
              <span
                class="credit-card-wallet__status"
                [class.credit-card-wallet__status--active]="card.status === 'active'">
                {{ card.status === "active" ? "Ativo" : card.status }}
              </span>
            </div>
            <div class="credit-card-wallet__number">{{ formatCardNumber(card) }}</div>
            <div class="credit-card-wallet__details">
              <span class="credit-card-wallet__holder">{{ card.holder_name }}</span>
              <span class="credit-card-wallet__expiry"> Expira em {{ formatExpiryDate(card) }} </span>
            </div>
          </div>
        }
        @if (showDelete) {
          <button
            type="button"
            class="credit-card-wallet__delete"
            [attr.aria-label]="'Remover cartão ' + card.last_four_digits"
            (click)="handleDeleteClick(card, $event)">
            <i class="pi pi-trash"></i>
          </button>
        }
      </div>
    }
  </div>
</div>
